import Page from 'components/modules/public/pages/RegisterEmployee';
export default Page;